import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';

import storage from '@/services/local-storage';
import usePwaInstall from '@/composables/pwa-install';

//  PWA Promo Bar

export default /*#__PURE__*/_defineComponent({
  __name: 'PwaInstallBar',
  setup(__props) {

const { isInstallable, installPrompt } = usePwaInstall();

const installBar = ref(false);

watch(isInstallable, () => {
  if (storage.getPwaBarDismissCount() >= 3) {
    console.log(`PWA Bar dismissed ${storage.getPwaBarDismissCount()} times, not showing again.`);
    installBar.value = false;
    return;
  }
  installBar.value = isInstallable.value;
});

const dismissBar = () => {
  installBar.value = false;
  storage.setPwaBarDismissCount(storage.getPwaBarDismissCount() + 1);
};


return { __sfc: true,isInstallable, installPrompt, installBar, dismissBar }
}

})